import { connect } from 'react-redux';
import { toggleUserProfile } from '../../../actions/navigation';
import { location } from '../../../selectors/routing';
import UserProfile from './UserProfile';
import TABS from './Tabs';

const mapStateToProps = (state) => ({
  shouldShowUserProfile: location(state).search.includes('user-profile'),
  tabs: TABS,
});

const mapDispatchToProps = {
  closeModal: toggleUserProfile,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserProfile);
